import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const Div = styled.div`
  left: 0;
  top: 58px;
  padding: 0;
  width: 100%;
  height: 725px;
  margin: auto;
  display: flex;
  outline: none;
  z-index: 1000;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-top: 20px;
  position: absolute;
  align-items: center;
  background: #ffffff;
  border-radius: 12px;
  flex-direction: column;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const None = styled.div`
  display: none;
`;

const StyledList = styled(List)`
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
`;

function RenderListItem(selected) {
  function Render({ title, link, links }, index) {
    function open(e) {
      e.stopPropagation();
      window.open(link, '_blank');
    }

    const isSelected = selected === index;
    const secondary = links ? links.join(' and ') : link;

    return (
      <ListItem
        button
        key={index}
        selected={isSelected}
        onMouseDown={open}
      >
        <ListItemText primary={title} secondary={secondary} />
      </ListItem>
    );
  }

  Render.propTypes = {
    link: PropTypes.string,
    title: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.string),
  };

  Render.defaultProps = {
    link: '',
    links: [],
  };

  return Render;
}

function Results({ items, focus, selected }) {
  if (!focus || !items || !items.length) return <None />;

  const list = items.map(RenderListItem(selected));

  return (
    <Div>
      <StyledList>{list}</StyledList>
    </Div>
  );
}

Results.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string.isRequired,
      links: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
  focus: PropTypes.bool.isRequired,
  selected: PropTypes.number.isRequired,
};

const mapStateToProps = ({
  search: { index: selected, results: items, focus },
}) => ({
  items,
  focus,
  selected,
});

const connected = connect(mapStateToProps)(Results);

export default connected;
